import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import classNames from 'classnames';
import PlainText from '../../PlainText/index.js';
import styles from './styles.css.js';

var DefaultCard = function DefaultCard(_ref) {
  var choice = _ref.choice,
      disabled = _ref.disabled,
      isSelected = _ref.isSelected,
      onHandleChange = _ref.onHandleChange;
  return React.createElement("label", {
    className: styles.wrapper,
    htmlFor: choice.id
  }, React.createElement("input", {
    id: choice.id,
    name: choice.id,
    type: "checkbox",
    className: styles.input,
    value: choice.id,
    disabled: disabled,
    checked: isSelected,
    onChange: function onChange(ev) {
      onHandleChange({
        choiceId: choice.id,
        isChecked: ev.target.checked
      });
    }
  }), React.createElement("div", {
    className: classNames(styles.pill, _defineProperty({}, styles.selected, isSelected))
  }, choice.text && React.createElement("div", {
    className: styles.headline
  }, React.createElement(PlainText, {
    plainTextEntry: choice.text
  }))));
};

export default DefaultCard;
//# sourceMappingURL=index.js.map
